module.exports = __webpack_public_path__ + "static/media/sample-serial.83be2447.svg";